import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-background">
        <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground mb-2">Terms &amp; Conditions</h1>
            <p className="text-sm sm:text-base text-muted-foreground mb-6 sm:mb-8">Last updated: December 23, 2024</p>

            <div className="space-y-4 sm:space-y-6 lg:space-y-8">
              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">1. Acceptance of Terms</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  By accessing and using Pharmasoft CS Director services provided by KIREETI SOFT TECHNOLOGIES LIMITED., you accept and agree to be bound by the terms and
                  provisions of this agreement. If you do not agree to abide by these terms, please do not use this service.
                </p>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">2. Subscription Services</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-3 sm:mb-4">
                  Pharmasoft CS Director offers subscription-based services with the following terms:
                </p>
                <ul className="list-disc list-inside text-sm sm:text-base text-muted-foreground space-y-1.5 sm:space-y-2">
                  <li>Basic Plan: ₹2,500 + GST per year</li>
                  <li>Core Plan: ₹4,000 + GST per year</li>
                  <li>Advanced Plan: ₹6,000 + GST per year</li>
                  <li>Billing is recurring on an annual basis</li>
                  <li>All prices are in Indian Rupees (INR)</li>
                </ul>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">3. Payment Terms</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  Payment is due at the beginning of each billing cycle. We accept major credit cards and debit cards. All payments are processed securely through our
                  payment gateway. GST will be applied as per applicable rates.
                </p>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">4. Cancellation Policy</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  You may cancel your subscription at any time. Upon cancellation, you will continue to have access to the service until the end of your current billing
                  period. Please refer to our{" "}
                  <Link to="/refund" className="text-primary hover:underline">
                    Refund &amp; Cancellation Policy
                  </Link>{" "}
                  for detailed information.
                </p>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">5. User Responsibilities</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  Users are responsible for maintaining the confidentiality of their account credentials, all activities under their account, and ensuring their use of
                  the service complies with applicable laws and regulations.
                </p>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">6. Limitation of Liability</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                KIREETI SOFT TECHNOLOGIES LIMITED. shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of
                  Pharmasoft CS Director. Our total liability shall not exceed the amount paid by you in the preceding 12 months.
                </p>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">7. Contact Information</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  For any questions regarding these terms, please{" "}
                  <Link to="/contact" className="text-primary hover:underline">
                    contact us
                  </Link>
                  .
                </p>
              </section>
            </div>
          </div>
        </main>

        <footer className="border-t border-border mt-8 sm:mt-12 lg:mt-16 py-6 sm:py-8">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm text-muted-foreground">
              <Link to="/about" className="hover:text-foreground transition-colors">
                About Us
              </Link>
              <Link to="/terms" className="hover:text-foreground transition-colors">
                Terms &amp; Conditions
              </Link>
              <Link to="/privacy" className="hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="/refund" className="hover:text-foreground transition-colors">
                Refund &amp; Cancellation
              </Link>
              <Link to="/contact" className="hover:text-foreground transition-colors">
                Contact Us
              </Link>
            </div>
            <p className="text-center text-sm text-muted-foreground mt-4">
              © {new Date().getFullYear()}{" "}
              <a
                href="https://kireetisoft.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground transition-colors underline"
              >
                KIREETI SOFT TECHNOLOGIES LIMITED.
              </a>{" "}
              All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </Layout>
  );
};

export default Terms;

